import { render } from "./CareerDetailView.vue?vue&type=template&id=e4e00dd2"
import script from "./CareerDetailView.vue?vue&type=script&lang=js"
export * from "./CareerDetailView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__